<template>
  <AccordionItem v-if="isFileItem && !multipleItemsSelected" id="transactions">
    <AccordionHeader>
      <Icon :size="16" name="Clock" class="stroke-gray-800 mr-2" />
      <div
        class="font-semibold font-primary text-[14px] leading-[20px] text-gray-800 tracking-[-0.18px]"
      >
        Transaction History
      </div>
    </AccordionHeader>
    <AccordionContent class="overflow-y-auto pb-3">
      <div class="font-secondary text-[13px] text-gray-800/50 px-[14px]">
        No transactions available
      </div>
    </AccordionContent>
  </AccordionItem>
</template>

<script setup lang="ts">
import {
  AccordionContent,
  AccordionHeader,
  AccordionItem,
} from '@/shared/components/Accordion'
import { Icon } from '@dacr/ui'
import type { SidebarItem } from './Sidebar.vue'

defineProps<{
  item: SidebarItem
  isFileItem: boolean
  multipleItemsSelected: boolean
}>()
</script>
